import subCategoryStore from 'js/stores/store';
import subCategoryActions from 'js/actions/actions';

import React from 'react';

const basePath = window.location.href.split('#')[0];

// window.onhashchange = hash => {
//   let newHash = hash.newURL.split('#')[1];
//   let oldHash = hash.oldURL.split('#')[1];

//   if (newHash === '/') {
//     subCategoryActions.removeFromBreadCrumbs(0);
//   }

//   if (
//     oldHash &&
//     oldHash.indexOf('single') > -1 &&
//     newHash.indexOf('subcat') > -1
//   ) {
//     subCategoryActions.removeFromBreadCrumbs(1);
//   }
// };

let openUrl = url => {
  subCategoryStore.getState().breadcrumbs.map(function(b, i) {
    if (b.link === url) {
      subCategoryActions.removeFromBreadCrumbs(i);
    }
  });
  window.open(basePath + url, '_self');
};

export class BreadCrumbs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...subCategoryStore.getState()
    };
    subCategoryStore.subscribe(this.storeUpdated.bind(this));
  }

  storeUpdated() {
    this.setState(subCategoryStore.getState());
  }

  render() {
    let BreadCrumb = (b, i) => {
      return (
        <span key={'bread-' + i} className='padding--small'>
          <div className='inline-block' onClick={openUrl.bind(this, b.link)}>
            {b.text}
          </div>
        </span>
      );
    };

    return (
      <div className='bread-crumb-container'>
        {this.state.breadcrumbs.map(function(b, i) {
          return BreadCrumb(b, i);
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/toolbar/breadcrumbs.js